module.exports = __webpack_public_path__ + "static/media/book5cover_preview.603ba58f.png";